<form [formGroup]="filtersForm">

	@if (isCustomerCare()) {
	<div class="form-group">
		<a data-testid="SUBSYS5_LISTSEARCH_CLEAR_BTN" href="#" onclick="return false;" class="clear-filter"
			(click)="clear()" (keypress)="clear()">
			{{ labels().FILTERS_COMPONENT_CLEAR_FILTERS }}
		</a>

		<label data-testid="SUBSYS5_LISTSEARCH_USERNAME_LBL" for="userName">
			{{ labels().FILTERS_COMPONENT_USERNAME }}
		</label>
		<input data-testid="SUBSYS5_LISTSEARCH_USERNAME_INPUT" type="text" class="form-control" id="userName"
			[placeholder]="labels().FILTERS_COMPONENT_USERNAME" formControlName="userName"
			[class.is-invalid]="userName.invalid && userName.touched" />
		<div class="invalid-feedback">
			@if(userName.hasError('pattern')) {
			{{ labels().VALIDATION_EMAIL | replace:labels().FILTERS_COMPONENT_USERNAME }}
			}
			@else if(userName.hasError('maxlength')) {
			{{ labels().VALIDATION_MAXLENGTH | replace:labels().FILTERS_COMPONENT_USERNAME:USERNAME_MAXLENGTH }}
			}
			@else if(userName.hasError('userNameNotExists')) {
			{{ labels().VALIDATION_NOT_EXISTS | replace:labels().FILTERS_COMPONENT_USERNAME }}
			}
		</div>
	</div>
	}

	<div class="form-group">
		@if (!isCustomerCare()) {
		<a data-testid="SUBSYS5_LISTSEARCH_CLEAR_BTN" href="#" onclick="return false;" class="clear-filter"
			(click)="clear()" (keypress)="clear()">
			{{ labels().FILTERS_COMPONENT_CLEAR_FILTERS }}
		</a>
		}
		<label data-testid="SUBSYS5_LISTSEARCH_PATID_LBL" for="patientID">{{ labels().FILTERS_COMPONENT_PATIENTID }}</label>
		<input data-testid="SUBSYS5_LISTSEARCH_PATID_INPUT" type="text" class="form-control" id="patientID"
			[placeholder]="labels().FILTERS_COMPONENT_PATIENTID" formControlName="patientId"
			[class.is-invalid]="patientId.invalid && patientId.touched" />
		<div class="invalid-feedback">
			@if(patientId.hasError('maxlength')) {
			{{ labels().VALIDATION_MAXLENGTH | replace:labels().FILTERS_COMPONENT_PATIENTID:ID_MAXLENGTH }}
			}
		</div>
	</div>

	<div class="form-group">
		<label data-testid="SUBSYS5_LISTSEARCH_PLANID_LBL" for="planID">{{ labels().FILTERS_COMPONENT_PLANID }}</label>
		<input data-testid="SUBSYS5_LISTSEARCH_PLANID_INPUT" type="text" class="form-control" id="planID"
			[placeholder]="labels().FILTERS_COMPONENT_PLANID" formControlName="planId"
			[class.is-invalid]="planId.invalid && planId.touched" />
		<div class="invalid-feedback">
			@if(planId.hasError('maxlength')) {
			{{ labels().VALIDATION_MAXLENGTH | replace:labels().FILTERS_COMPONENT_PLANID:ID_MAXLENGTH }}
			}
		</div>
	</div>


	<div class="form-group">
		<label data-testid="SUBSYS5_LISTSEARCH_FRAMEID_LBL" for="frameID">{{ labels().FILTERS_COMPONENT_FRAMEID }}</label>
		<input data-testid="SUBSYS5_LISTSEARCH_FRAMEID_INPUT" type="text" class="form-control" id="frameID"
			[placeholder]="labels().FILTERS_COMPONENT_FRAMEID" formControlName="frameId"
			[class.is-invalid]="frameId.invalid && frameId.touched" />
		<div class="invalid-feedback">
			@if(frameId.hasError('pattern')) {
			{{ labels().VALIDATION_FRAMEID | replace:labels().FILTERS_COMPONENT_FRAMEID }}
			}
		</div>
	</div>

	<div class="form-group">
		<label data-testid="SUBSYS5_LISTSEARCH_STATUS_LBL" for="status">{{ labels().FILTERS_COMPONENT_STATUS }}</label>
		<select data-testid="SUBSYS5_LISTSEARCH_STATUS_SELECT" class="form-control custom-select" id="status"
			formControlName="status" [class.is-invalid]="status.invalid && status.touched">
			<option [ngValue]="null">{{ labels().FILTERS_COMPONENT_ALL_VALUE }}</option>
			@for (status of statusList; track $index) {
			<option [ngValue]="status">{{ status | planStatusLabel }}</option>
			}
		</select>
	</div>

	<div class="form-group">
		<label data-testid="SUBSYS5_LISTSEARCH_SIDE_LBL" for="side">{{ labels().FILTERS_COMPONENT_SIDE }}</label>
		<select data-testid="SUBSYS5_LISTSEARCH_SIDE_SELECT" class="form-control custom-select" id="side"
			formControlName="side" [class.is-invalid]="side.invalid && side.touched">
			<option [ngValue]="null">{{ labels().FILTERS_COMPONENT_ALL_VALUE }}</option>
			@for (side of sideList; track $index) {
			<option [ngValue]="side">{{ side | anatomicalSideLabel }}</option>
			}
		</select>
	</div>

	<div class="form-group">
		<label data-testid="SUBSYS5_LISTSEARCH_BONE_LBL" for="boneType">{{ labels().FILTERS_COMPONENT_BONETYPE }}</label>
		<select data-testid="SUBSYS5_LISTSEARCH_BONE_SELECT" class="form-control custom-select" id="boneType"
			formControlName="boneType" [class.is-invalid]="boneType.invalid && boneType.touched">
			<option [ngValue]="null">{{ labels().FILTERS_COMPONENT_ALL_VALUE }}</option>
			@for (boneType of boneTypeList; track $index) {
			<option [ngValue]="boneType">{{ boneType | boneTypeLabel }}</option>
			}
		</select>
	</div>

	<div class="form-group" #publishDateTarget>
		<label data-testid="SUBSYS5_LISTSEARCH_PUBLISHDATE_LBL" for="publishDate">
			{{ labels().FILTERS_COMPONENT_PUBLISH_DATE }}
		</label>
		<div class="input-group wrapper-calendar">
			<i data-testid="SUBSYS5_LISTSEARCH_PUBLISHDATE_TOGGLE_BTN" class="material-icons input-group-append icon-calendar"
				(click)="publishDatePicker.toggle()" (keypress)="publishDatePicker.toggle()">today</i>
			<input data-testid="SUBSYS5_LISTSEARCH_PUBLISHDATE_INPUT" class="form-control text-white" type="text"
				[placeholder]="labels().FILTERS_COMPONENT_PUBLISH_DATE" name="publishDateRange" [value]="publishDateFormat()"
				readonly>
			<i data-testid="SUBSYS5_LISTSEARCH_PUBLISHDATE_CLEAR_BTN"
				class="material-icons input-group-append align-self-center md-18" (click)="publishDate.set(null)"
				(keypress)="publishDate.set(null)">clear</i>
		</div>
	</div>
	<datepicker data-testid="SUBSYS5_LISTSEARCH_PUBLISHDATE_DATEPICKER" #publishDatePicker [value]="publishDate()"
		(dateChanged)="publishDate.set($event)" [positionTarget]="publishDateTarget" placement="bottom-left" />

	<div class="form-group ps-5">
		<select data-testid="SUBSYS5_LISTSEARCH_DATEFILTER_SELECT" class="form-control custom-select" id="dateFilter"
			formControlName="dateFilter" [class.is-invalid]="dateFilter.invalid && dateFilter.touched">
			@for (dateFilter of dateFilterList; track $index) {
			<option [ngValue]="dateFilter">{{ dateFilter | dateFilterLabel }}</option>
			}
		</select>
	</div>

	<button data-testid="SUBSYS5_LISTSEARCH_SEARCH_BTN" type="button" class="btn btn-primary"
		[disabled]="filtersForm.invalid" (click)="search()" (keypress)="search()">
		{{ labels().FILTERS_COMPONENT_SEARCH_BTN }}
	</button>

</form>